// phone-mask-tr.directive.ts
import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appPhoneMaskTR]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PhoneMaskTRDirective),
    multi: true
  }]
})
export class PhoneMaskTRDirective implements ControlValueAccessor {
  private onChange: (val: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    const digits = (value ?? '').toString().replaceAll(/\D/g, '').slice(0, 10);
    this.el.nativeElement.value = formatTRPhone(digits);
  }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.el.nativeElement.disabled = isDisabled; }

  @HostListener('input', ['$event'])
  onInput() {
    const input = this.el.nativeElement;
    const digits = input.value.replaceAll(/\D/g, '').slice(0, 10);
    const formatted = formatTRPhone(digits);
    input.value = formatted;        // görünen
    this.onChange(digits);          // modele sadece rakam
  }

  @HostListener('blur') onBlur() { this.onTouched(); }
}

function formatTRPhone(d: string): string {
  const a = d.substring(0, 3);
  const b = d.substring(3, 6);
  const c = d.substring(6, 8);
  const e = d.substring(8,10);
  let out = '';
  if (a) out = `(${a}${a.length===3 ? ')' : ''}`;
  if (b) out += (a ? ' ' : '') + b;
  if (c) out += (b ? ' ' : '') + c;
  if (e) out += (c ? ' ' : '') + e;
  return out;
}
